import { injectable } from '@patsnap/tahiti-core/shared/inversify';
import type { AsyncComponent } from 'vue';
import Vue from 'vue';
import type { PatsnapCopilotIntentRenderer } from './patsnap-copilot-renderer';
import type { CopilotMessageTurn } from './patsnap-copilot-service.interface';

export const VueBaseExternalIntentRenderer = Symbol('VueBaseExternalIntentRenderer');

export interface VueBaseExternalIntentRenderer {
    createRenderer(component: AsyncComponent): { new(): PatsnapCopilotIntentRenderer };
}

@injectable()
export class VueBaseExternalIntentRendererImpl implements VueBaseExternalIntentRenderer {
    createRenderer(component: AsyncComponent) {
        const Ctx = class ExternalIntentRenderer implements PatsnapCopilotIntentRenderer {
            private _vm?: Vue = undefined;

            render({ turn }: { turn: CopilotMessageTurn; }) {
                this._vm = new Vue({
                    components: {
                        Renderer: component,
                    },
                    render: (h) => h('Renderer', { props: { turn } }),
                });
                this._vm.$mount();
                return Promise.resolve(this._vm.$el as HTMLElement);
            }

            dispose() {
                if (this._vm) {
                    this._vm.$destroy();
                    this._vm = undefined;
                }
            }
        }

        return Ctx;
    }
}
